<template>
  <div>
    <v-radio-group v-if="localItem.definition.isUnique"
                   :label="label"
                   :error-messages="fieldErrors"
                   v-model="localItem.answer.answer"
                   @change="onChange"
    >
      <v-radio
        v-for="response in localItem.definition.responses"
        :key="response.id"
        :label="response.text"
        :value="response.text"
        color="valid"
      />
    </v-radio-group>

    <div v-else class="questionnaire__checkbox__group">
      <div class="questionnaire__checkbox__group__label v-label theme--light"
           :class="{ label__error: error }"
      >{{ label }}
      </div>
      <v-checkbox v-for="answer in answers"
                  :key="answer.id"
                  :label="answer.text"
                  :value="answer.text"
                  :error="error"
                  color="valid"
                  v-model="answer.value"
      />
    </div>
  </div>
</template>

<script>
import itemMixin from '@/components/appUser/questionnaires/pageItems/itemMixin'
import { required } from 'vuelidate/lib/validators'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'QuestionMCItem',
  mixins: [itemMixin],
  data () {
    return {
      answers: [],
      oldAnswers: [],
      mcqErrors: false
    }
  },
  beforeMount () {
    if (!this.localItem.definition.isUnique) {
      // Reconstruit les réponses avec celle stockés dans la définition
      this.localItem.definition.responses.forEach(response => {
        this.answers.push({
          id: response.id,
          text: response.text,
          value: null
        })
      })

      // Vérifie celles qui étaient cochées grâce au champ "answer"
      if (this.localItem.answer.answer !== null) {
        this.localItem.answer.answer.split(/\n/)
          .forEach(response => {
            if (response !== '') {
              this.answers.map(answer => {
                if (answer.text === response) {
                  answer.value = response
                  if (!this.$v.$anyDirty) this.$v.$touch()
                }
              })
            }
          })
      }
    }

    // Stocke les données dans le tableau old pour les vérifications ultérieures.
    this.archiveAnswers()
  },
  computed: {
    ...mapGetters('User', [
      'user'
    ]),
    ...mapGetters('UserQuestionnaire', [
      'changePage',
      'questionnaire'
    ]),
    label () {
      return this.localItem.definition.question + (
        this.localItem.definition.required ? ' *' : ''
      )
    },
    fieldErrors () {
      const errors = []
      if (!this.$v.localItem.answer.answer.$dirty) return errors
      if (this.localItem.definition.required && !this.$v.localItem.answer.answer.required) {
        errors.push('Cette question est obligatoire')
      }
      return errors
    },
    error () {
      return this.mcqErrors
    }
  },
  watch: {
    changePage () {
      // Lance la vérification sur les champs
      this.$v.$touch()

      // Si c'est une MCQ
      if (this.changePage &&
        !this.localItem.definition.isUnique &&
        this.localItem.definition.required
      ) {
        // Le champ erreur est modifié à true si toutes les réponses sont nulles
        // Vérification faites à l'essai de changement de page.
        this.hasErrors(this.answers)
      }
    },
    answers: {
      // Rend dynamique l'écoute d'un tableau
      deep: true,
      handler: function (answers) {
        let newValues = JSON.stringify(this.oldAnswers) !== JSON.stringify(answers)
        // Vérifie si la vérification a été déjà été lancée une fois
        // et si les valeurs dans les réponses sont différentes des valeurs stockées dans old =
        // permet de vérifier qu'on est pas à l'initialisation du composant.
        if (this.$v.$anyDirty && newValues) {
          this.hasErrors(answers)
        }

        this.localItem.answer.answer = ''

        this.answers.forEach(answer => {
          if (answer.value !== null) {
            this.localItem.answer.answer += `${answer.value}\n`
          }
        })

        if (
          (!this.localItem.definition.required || this.localItem.answer.answer !== '') &&
          newValues &&
          (this.questionnaire.isPublished || this.questionnaire.user === this.user.id)
        ) {
          this.sendAnswer({
            questionId: parseInt(this.localItem.value),
            answer: this.localItem.answer
          })
        }

        // Sauvegarde les nouvelles valeur dans old pour la prochaine vérification
        this.archiveAnswers()
      }
    }
  },
  validations: {
    localItem: {
      answer: {
        answer: {
          required
        }
      }
    }
  },
  methods: {
    ...mapActions('UserQuestionnaire', [
      'sendAnswer'
    ]),
    hasErrors (answers) {
      this.mcqErrors = answers.every(answer => {
        return answer.value === null
      }) && this.localItem.definition.required
    },
    archiveAnswers () {
      this.oldAnswers = JSON.parse(JSON.stringify(this.answers))
    },
    onChange () {
      if (
        this.localItem.answer.answer !== null &&
        (this.questionnaire.isPublished || this.questionnaire.user === this.user.id)
      ) {
        this.sendAnswer({
          questionId: parseInt(this.localItem.value),
          answer: this.localItem.answer
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  div {
    .questionnaire__checkbox__group {
      margin-top: 16px;
      padding-top: 5px;
      display: flex;
      flex-direction: column;

      .questionnaire__checkbox__group__label {
        margin-bottom: 8px;
      }

      .v-input--checkbox {
        margin-top: 0;
        margin-bottom: 8px;
      }
    }

    .label__error {
      color: rgb(255, 82, 82);
    }
  }
</style>
